export function getViewportSize() {
  "use strict";

  return {
    w: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
    h: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  }
}



/** WEBPACK FOOTER **
 ** ./src/script/utils/responsive.js
 **/